import {Injectable} from "@angular/core";

@Injectable()
export class SpinnerService {

    public flag: boolean = false;

    public show(): void {
        this.flag = true;
    }

    public hide(): void {
        this.flag = false;
    }

    public isLoading(): boolean {
        return this.flag;
    }
}